// Scroller

function initScrollers() {
  document.querySelectorAll(".scroller").forEach((scroller) => {
    const scroller_container = scroller.querySelector(".scroller__container");
    if (!scroller_container) return;

    const scroller_items = Array.from(scroller_container.children);

    scroller_items.forEach((item) => {
      const duplicate = item.cloneNode(true);
      duplicate.setAttribute("aria-hidden", true);
      scroller_container.appendChild(duplicate);
    });

    scroller.setAttribute("scroll", true);
  });
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    //

    // Datalayer
    if (window.dataLayer == undefined) window.dataLayer = [];

    // Scrollers
    initScrollers();

    const popover = document.getElementById("mob-menu");
    document.querySelectorAll("#mob-menu a").forEach((el) => {
      el.addEventListener("click", () => {
        popover.hidePopover();
      });
    });
  },
  false
);
